'use strict';

var GetIntrinsic = require('../GetIntrinsic');

var $Array = GetIntrinsic('%Array%'); // eslint-disable-next-line global-require

var toStr = !$Array.isArray && require('../helpers/callBound')('Object.prototype.toString'); // https://www.ecma-international.org/ecma-262/6.0/#sec-isarray


module.exports = $Array.isArray || function IsArray(argument) {
  return toStr(argument) === '[object Array]';
};